import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSortUp, faSortDown, faCheckCircle
} from '@fortawesome/pro-solid-svg-icons';
import {
  faExternalLinkAlt
} from '@fortawesome/pro-regular-svg-icons';
import { hideNav } from "./_util";
// import { columnNav } from "./views/columnNav";
// import { orangeHeaderSubPages } from "./views/orangeHeaderInYourOwnWords";
import { DateTime } from "luxon";
import Fuse from "fuse.js";

// const { apiServerURL } = require("../speechVault/_util");

const allowedFields = [
  "Device",
  "Device Code",
  "Chipset",
  "Available on Store"
],
  searchFields = allowedFields.slice(0, 3);

export const DevicesList = (viewRecordingsHandler, reviewRepairsHandler, reviewAppDeviceHandler) => {
  hideNav();
  if (window.document.location.pathname.match(/devices$/i))
    window.document.location.pathname = "/session/using-your-voice-speakunique-app-android";

  const [showSidebar] = useState( // sidebar's obsolete at the moment. might come back. navCollapsed controls it now.
    localStorage.getItem("showSidebar") ? Boolean(parseInt(localStorage.getItem("showSidebar"))) : true),
    [dataDumpData, setDataDumpData] = useState([]),
    [headers, setHeaders] = useState([]),
    [lastModified, setLastModified] = useState(),
    [currentYear] = useState(new Date().getFullYear()),
    [sortKey, setSortKey] = useState('Device'),
    [searchString, setSearchString] = useState(""),
    [isReversed, setIsReversed] = useState(false),
    [navCollapsed, setNavCollapsed] = useState(false),
    makeFooterTimestamp = () => DateTime.local().toLocaleString(DateTime.DATETIME_HUGE),
    [footerTimeStamp, setFooterTimeStamp] = useState(makeFooterTimestamp()),
    [roundValues, setRoundValues] = useState(true),
    openImageSearch = searchString => window.open(
      `https://www.google.com/search?tbm=isch&q=${encodeURIComponent(searchString)}`);

  useMemo(() => {
    const getData = async () => {
      // return;
      const response = await fetch(
        // apiServerURL +
        (window.document.location.hostname === "localhost" ? "https://dev23.speakunique.co.uk" : "") +
        // "" +
        "/api/devicesList", {
        method: "GET",
        crossDomain: true,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }),
        data = response.ok ? await response.json() : {},
        sortIsNumeric = !!sortKey.match(/time|ranking/i);

      setDataDumpData(data && data.results && data.results.length ? data.results.sort((a, b) =>
        sortIsNumeric ?
          (isReversed ? parseFloat(a[sortKey]) - parseFloat(b[sortKey]) : parseFloat(b[sortKey]) - parseFloat(a[sortKey])) :
          (isReversed ? (b[sortKey] || '').localeCompare(a[sortKey]) : (a[sortKey] || '').localeCompare(b[sortKey]))) : []);
      setHeaders(data.headers);
      setLastModified(data.LastModified);
    };

    getData();
    window.setInterval(() => setFooterTimeStamp(makeFooterTimestamp()), 2000);
  }, [roundValues, footerTimeStamp, sortKey, isReversed]);

  const columnHeaders = allowedFields,
    fuseOptions = { keys: searchFields, minMatchCharLength: 2 },
    fuse = new Fuse(dataDumpData, fuseOptions),
    searchFilter = searchString => {
      if (!searchString) return dataDumpData;
      const matches = fuse.search(searchString);
      return matches.map(e => e.item);
    };

  return <div className={`${window.document.location.pathname.match(/devices$/i) ? "is-hidden" : null}`}>
    <div className="columns">
      <div className="column is-10 is-offset-1">
        {/* {orangeHeaderSubPages("")} */}

        <div className="columns">
          <div className="column is-10 is-offset-1">

            <div className="" style={{
              padding: 20,
              fontSize: "16pt",
              fontFamily: "JAF Domus, Quicksand, sans-serif",
            }}
            >
              {/* These devices have been tested by SpeakUnique for app compatibility.<br /><br /> */}

              The SpeakUnique app is compatible with a range of Android devices. The device must be fast enough to run our voices through the app, determined by the chip within the device, and this means we cannot support all Android devices on the market.  The list below shows the Android devices our app has been tested on and if the device is or is not compatible with our app.

              <div style={{
                marginTop: 12,
                marginBottom: 12,
                fontWeight: 600
              }}>
                Please carefully check the make and model of your device against the list shown, to confirm if our app will run on your device.
              </div>

              {/* , <a href="https://play.google.com/store/apps/details?id=uk.co.speakuniquespeedtest&pcampaignid=web_share"
                style={{
                  fontWeight: 500
                }}
                className="orange xhinted"
                target="_blank" rel="noopener">but you can download our "SpeakUnique Speed Test" app free from the Google Play store <FontAwesomeIcon icon={
                  faExternalLinkAlt
                } title={`This link to the Google Play store will open in a new window`}
                />
              </a> to check your own device!{" "} */}
              {/* Please search for "SpeakUnique Speed Test".  */}
              If your device is not shown on the below list, it means we have not tested your device. You can download our speed testing app free from the Google Play store. Please search for “SpeakUnique Speed Test”. The app is free to download and will confirm your device's compatibility by running a short test. The test will take less than 1 minute to complete and will immediately tell you if your device is compatible with the SpeakUnique app. Once you have run the test, you can delete the speed test app from your device.

              <div style={{
                marginTop: 12,
                marginBottom: 12,
                fontWeight: 600
              }}>
                For assistance contact our support team <a href="mailto:support@speakunique.co.uk"
                  className="orange hinted">support@speakunique.co.uk</a>.
              </div>
            </div>
          </div>
        </div>
        {/* <br /> */}
        {/* Search this list: */}
        {dataDumpData.length ?
          <div>
            {/* <div className="columns">
              <div className="column">
                {dataDumpData.length ? dataDumpData.length : 0} devices
              </div>
              <div className="column has-text-right">
              </div>
            </div> */}
            <div className="xhas-text-centered" style={{
              fontFamily: "JAF Domus,Quicksand,sans-serif"
            }}>
              <div className="columns">
                <div className="column xis-10 xs-offset-1">
                  <div style={{
                    marginLeft: 80, marginRight: 80,

                  }}>
                    <div style={{
                      fontWeight: 600,
                      fontSize: "16pt"
                    }}>
                      SpeakUnique Devices List
                    </div>
                    <table
                      // cellPadding="0" cellSpacing="0"
                      style={{
                      }}
                      className="table is-striped">
                      <thead>
                        <tr>
                          {columnHeaders.map((key, idx) => {
                            return <th key={`th${idx}`}
                              className={key.match(/time|ranking/i) ? "has-text-right" : null}
                            // title={`Click to sort by ${key}`}
                            // onClick={() => {
                            //   if (sortKey === key) setIsReversed(!isReversed);
                            //   else setSortKey(key);
                            // }}
                            ><nobr>
                                {`${key}`.replace(/on Store/, "on App Store")}
                                {/* {" "}
                        {key.replace(/(?=[A-Z0-9])/g, " ")
                          .replace(/Time ([0-9]+)/, "T$1")
                          .replace(/Average Time/, "Avg Time")
                          .replace(/ *\(s\)$/i, "")
                          .replace(/^([a-z])/, "$1".toLocaleUpperCase())
                        } {
                          sortKey === key ? <FontAwesomeIcon icon={
                            isReversed ? faSortUp : faSortDown} /> : null
                        } */}
                              </nobr>
                              {key === "Device" ?
                                <input type="text"
                                  className="xinput xtext"
                                  style={{
                                    marginLeft: 20,
                                    fontSize: "8pt",
                                    fontFamily: "JAF Domus,Quicksand,sans-serif"
                                  }}
                                  defaultValue={searchString}
                                  placeholder="Search..."
                                  onChange={e => {
                                    e.preventDefault();
                                    setSearchString(e.target.value);
                                  }}
                                />
                                : null}
                            </th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {
                          (searchString && `${searchString}`.length > 1 ?
                            searchFilter(searchString) :
                            dataDumpData)
                            // .filter(ee => !searchString || `${JSON.stringify(ee)}`.match(new RegExp(searchString, "i")))
                            // .filter(ee => ee && `${ee['Available on Store']}`.match(/^supported/i)) // only display available ones
                            .map((row, idx) => {
                              let diff = null,
                                avg1 = null,
                                avg2 = null,
                                titleText = "";

                              const availableOnStore = `${row['Available on Store']}`.match(/^supported/i),
                                availableValue = availableOnStore ? "Yes" : "No";

                              return <tr key={`row${idx}`}>
                                {columnHeaders.map((key, idx2) => {
                                  const valIsAString = true, // !!(row && row[key] && (!key.match(/time/i))),
                                    valIsADateTime = false, // !!(key === "at" && row[key]),
                                    valIsANumber = false, // (!valIsADateTime && !valIsAString && (!!parseFloat(row[key]))),
                                    value = valIsADateTime ?
                                      DateTime.fromISO(row[key]).toLocaleString(DateTime.DATETIME_SHORT).replace(/\/[0-9]{4}, /, " ") :
                                      (valIsAString ?
                                        `${row[key]}`
                                          .replace(/,(?! )/g, ", ")
                                        : (valIsANumber ? parseFloat(row[key]) :
                                          row[key])),
                                    tdContent = true || key.match(/model|device|chip/i) ? <span
                                      className="orange"
                                    // style={{ fontSize: "small" }}
                                    // href="https://www.google.co.uk/"
                                    // title={`Search Google for "${value || ""}.replace(/"/g, "'")}"`}
                                    // onClick={e => { e.preventDefault(); openImageSearch(value); return false }}
                                    >
                                      {/* <FontAwesomeIcon icon={faExternalLinkAlt} className="orange"
                              style={{ marginRight: "7px" }}
                            /> */}
                                      {key.match(/available/i) ?
                                        <span style={{}}>{availableValue}</span> : value}
                                      {/* {value} */}
                                    </span> : (value === "N/A" ? "" :
                                      (valIsANumber ? (roundValues ? parseFloat(value).toFixed(3).toLocaleString() : value) :
                                        <span>
                                          {value === "Supported " ? "Yes" : null}
                                          {["Excluded ", "Missing "].includes(value) ? null : null}
                                          {/* {value}
                                {value === "Supported" ? <FontAwesomeIcon icon={faCheckCircle} style={{ marginLeft: "8px", color: "grey" }} /> : null} */}
                                        </span>
                                      ));

                                  // if (valIsANumber && key.match(/time/i)) {
                                  //   if (key.match(/skittles/i) && !avg1) avg1 = value;
                                  //   if (key.match(/custard/i) && !avg2) avg2 = value;
                                  // }
                                  // if (!!avg1 && !!avg2 && !diff) {
                                  //   const d = (avg2 - avg1) / avg1 * 100;
                                  //   diff = sprintf("%d%%", 100 - Math.abs(d));
                                  //   titleText = `The average Custard time (${avg2}) is ${diff.replace(/^\+/, "")
                                  //     } of the average Skittles time of (${avg1}).`;
                                  // }
                                  const extraTd = false && idx2 === 0 ?
                                    <td className="has-text-centered" >{idx + 1}</td> : null;

                                  return <>{extraTd}<td key={`td${idx}-${idx2}`}
                                    style={{
                                      minWidth: 250,
                                      maxWidth: 400,
                                      fontWeight: key.match(/^(?:available|device(?!.))/i) ? 500 : null
                                    }}
                                    title={row[key]}
                                    className={key.match(/time|ranking/i) ?
                                      'has-text-right' :
                                      (key.match(/available/i) ? "has-text-centered" : null)}
                                  ><nobr>{tdContent}</nobr></td></>;
                                })}
                                {/* <td
                        className="has-text-right"
                        title={titleText}
                      >{diff}</td> */}
                              </tr>
                            })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          : null}
      </div>
    </div>

    <hr />
    <div className="column has-text-centered"
      style={{ padding: 0, paddingRight: 4, fontSize: 'small' }} id="bottomTimestamp">
      Copyright &copy;{currentYear} SpeakUnique
      {/* {" "} */}
      {/* {footerTimeStamp} */}
    </div>
  </div>;
};
